import { Link } from "react-router-dom";
import { Newspaper, Calendar, ArrowRight, Flame, Eye, Clock } from "lucide-react";
import { formatReadingTime } from "../../lib/readingTime";

const mostReadOf = (articles) => articles.reduce((max, a) => ((a.views || 0) > (max.views || 0) ? a : max), articles[0]).id;

const NewsCard = ({ a, isMostRead }) => (
  <Link to={`/blog/${a.slug}`} data-testid={`news-card-${a.slug}`} className="card-hover rounded-xl overflow-hidden border border-[color:var(--border)] bg-[color:var(--bg-elev)] block relative">
    {a.cover_image && (
      <div className="aspect-[16/9] bg-black overflow-hidden relative">
        <img src={a.cover_image} alt={a.title} className="w-full h-full object-cover" />
        <div className="absolute top-2 left-2 px-2 py-0.5 bg-[color:var(--accent)] text-black text-[10px] uppercase tracking-widest font-bold rounded">Article</div>
        {isMostRead && (
          <div data-testid={`most-read-badge-${a.slug}`} className="absolute top-2 right-2 inline-flex items-center gap-1 px-2 py-0.5 bg-gradient-to-r from-orange-500 to-red-500 text-white text-[10px] uppercase tracking-widest font-bold rounded shadow-lg">
            <Flame className="w-3 h-3" /> Le + lu
          </div>
        )}
      </div>
    )}
    <div className="p-5">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-[color:var(--text-muted)] mb-2 flex-wrap">
        <Calendar className="w-3 h-3" />
        {new Date(a.published_at).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" })}
        <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" /> {formatReadingTime(a.content)}</span>
        {a.tags?.[0] && <span className="px-2 py-0.5 rounded-full bg-[color:var(--bg)] border border-[color:var(--border)] normal-case">{a.tags[0]}</span>}
        {typeof a.views === "number" && <span className="inline-flex items-center gap-1 ml-auto text-[color:var(--text-muted)]"><Eye className="w-3 h-3" /> {a.views}</span>}
      </div>
      <h3 className="font-display text-2xl leading-tight line-clamp-2 mb-2">{a.title}</h3>
      <p className="text-xs text-[color:var(--text-muted)] line-clamp-2">{a.excerpt}</p>
    </div>
  </Link>
);

export const NewsSection = ({ articles }) => {
  if (articles.length === 0) return null;
  const mostReadId = mostReadOf(articles);
  return (
    <section className="max-w-[1400px] mx-auto px-6 py-12 border-t border-[color:var(--border)]">
      <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <Newspaper className="w-5 h-5 text-[color:var(--accent)]" />
          <h2 className="font-display text-3xl">Actualités</h2>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--text-muted)]">Le journal Fedevo 2.0</span>
        </div>
        <Link to="/blog" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[color:var(--text-muted)] hover:text-[color:var(--accent)] transition-colors">
          Tous les articles <ArrowRight className="w-3.5 h-3.5" />
        </Link>
        <Link to="/blog/top" data-testid="link-blog-top" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[color:var(--text-muted)] hover:text-[color:var(--accent)] transition-colors">
          <Flame className="w-3.5 h-3.5 text-[color:var(--accent)]" /> Top 10
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 stagger" data-testid="news-grid">
        {articles.map(a => <NewsCard key={a.id} a={a} isMostRead={a.id === mostReadId && (a.views || 0) > 0} />)}
      </div>
    </section>
  );
};
